export default function requestFullscreen() {
  const el = document.documentElement as any;
  if (el.requestFullscreen) {
    el.requestFullscreen();
  } else if (el.webkitRequestFullscreen) {
    el.webkitRequestFullscreen()
  } else if (el.mozRequestFullScreen) {
    el.mozRequestFullScreen();
  } else if (el.msRequestFullscreen) {
    el.msRequestFullscreen();
  }
  //@ts-ignore
  if(window.webkitFullscreen){
    //@ts-ignore
    window.webkitFullscreen.endabled();
  }
}